export default __webpack_public_path__ + "static/heroBg-fe0b7f2fef28bfe8c7eb855ebfbdb69f.png";